const reports = {
  exportPdf: 'Exporter en PDF',
  generatedBy: 'Généré par SpeedGauge Coach AI',
  exportDescription: 'Exporter la réponse de Coach AI au format PDF',
  exportingPdf: 'Exportation du PDF',
  exportFailed: "L'exportation du PDF a échoué",
  loadingMap: 'Chargement de la carte...',
  generatedAt: 'PDF {{timestamp}}',
  dataSources: 'Sources de données',
  staticMapCaption: 'Capture statique de la carte provenant de la vue cartographique de la conversation.',
  audit: {
    customer: 'Client',
    customerId: 'ID client',
    vehicleGroup: 'Groupe de véhicules',
    vehicleGroupId: 'ID du groupe de véhicules',
    user: 'Utilisateur',
    sessionId: 'ID de session',
    messageId: 'ID du message',
    messageTimestamp: 'Horodatage du message',
  },
  pdf: {
    confidential: '- CONFIDENTIEL -',
    verificationDisclaimer: 'Les résultats peuvent nécessiter un examen et une vérification',
    page: 'Page {{page}} sur {{total}}',
  },
  map: {
    location: 'Emplacement',
    title: 'Carte',
    snapshot: 'Capture de carte',
    speedLimitLookup: 'Recherche de limite de vitesse ({{coordinates}})',
    speedZone: '{{speed}} {{unit}} dans une zone de {{limit}} {{unit}} (+{{difference}})',
    speedLimit: '{{speed}} {{unit}} (limite {{limit}}, +{{difference}})',
    incident: 'Incident',
  },
} as const;

export default reports;